export const Learnsets: {[k: string]: LearnsetData} = {
	rotomfan: {
		learnset: {
			windbreaker: ["9L1"],
			aircutter: ["9L1"],
		},
	},
	rotomfrost: {
		learnset: {
			blizzard: ["9L1"],
			freezedry: ["9L1"],
		},
	},
	rotomheat: {
		learnset: {
			overheat: ["9L1"],
			lavaplume: ["9L1"],
		},
	},
	rotomwash: {
		learnset: {
			hydropump: ["9L1"],
			washaway: ["9L1"],
		},
	},
	rotommow: {
		learnset: {
			leafstorm: ["9L1"],
			grassknot: ["9L1"],
		},
	},
	magearnaoriginal: {
		learnset: {
			agility: ["8M"],
			aurasphere: ["9M", "9L66", "8M", "8L66"],
			aurorabeam: ["9L36", "8L36"],
			batonpass: ["9M", "8M"],
			bodyslam: ["9M"],
			brickbreak: ["9M", "8M"],
			calmmind: ["9M", "8M"],
			chargebeam: ["9M"],
			confuseray: ["9M"],
			craftyshield: ["8L54"],
			dazzlinggleam: ["9M", "8M"],
			defensecurl: ["9L6", "8L6", "8S0"],
			disarmingvoice: ["9M"],
			drainingkiss: ["8M"],
			eerieimpulse: ["9M", "8M"],
			electroball: ["9M", "8M"],
			electroweb: ["8M"],
			encore: ["9M", "8M"],
			endure: ["9M", "8M"],
			energyball: ["9M", "8M"],
			facade: ["9M"],
			falseswipe: ["9M", "8M"],
			flashcannon: ["9M", "9L72", "8M", "8L72", "8S0"],
			fleurcannon: ["9L90", "8L90", "8S0"],
			focusblast: ["9M", "8M"],
			gearup: ["8L24"],
			gigaimpact: ["9M", "8M"],
			grassknot: ["9M", "8M"],
			gravity: ["9M"],
			guardswap: ["8M"],
			gyroball: ["9M", "9L1", "8M", "8L1"],
			heavyslam: ["9M"],
			helpinghand: ["9M", "9L1", "8M", "8L1"],
			hyperbeam: ["9M", "8M"],
			icebeam: ["9M", "8M"],
			icespinner: ["9M"],
			imprison: ["9M", "8M"],
			irondefense: ["9M", "9L18", "8M", "8L18"],
			ironhead: ["9M", "9L60", "8M", "8L60"],
			lightscreen: ["9M", "8M"],
			lockon: ["9L42"],
			magneticflux: ["9L24"],
			mindreader: ["8L42"],
			mistyexplosion: ["9M", "8T"],
			mistyterrain: ["9M"],
			painsplit: ["9L78", "8L78"],
			playrough: ["9M"],
			powerswap: ["8M"],
			protect: ["9M", "8M"],
			psybeam: ["9M", "9L30", "8L30"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M", "8M"],
			rest: ["9M", "8M", "8S0"],
			rollout: ["9L12", "8L12"],
			round: ["8M"],
			selfdestruct: ["8M"],
			shadowball: ["9M", "8M"],
			shiftgear: ["8L48"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["8M"],
			snowscape: ["9M"],
			solarbeam: ["9M", "8M"],
			speedswap: ["8M"],
			steelbeam: ["9M", "8T"],
			steelroller: ["8T"],
			storedpower: ["8M"],
			substitute: ["9M", "8M"],
			sunnyday: ["9M"],
			swift: ["9M"],
			takedown: ["9M"],
			terablast: ["9M"],
			thunderbolt: ["9M", "8M"],
			thunderwave: ["9M", "8M"],
			triattack: ["8M"],
			trick: ["8M"],
			trickroom: ["9M", "8M"],
			voltswitch: ["9M", "8M"],
			zapcannon: ["9L84", "8L84"],
			zenheadbutt: ["9M", "8M"],
		},
		eventData: [
			{generation: 8, level: 50, nature: "Mild", ivs: {hp: 31, atk: 30, def: 30, spa: 31, spd: 31, spe: 0}, moves: ["fleurcannon", "flashcannon", "defensecurl", "rest"], pokeball: "cherishball"},
		],
	},
};
